import { Phone, ArrowRight, Star } from "lucide-react";
import { site, images } from "@/data/site";

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-[100svh] flex items-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={images.hero}
          alt="Roter Tesla Model 3"
          className="w-full h-full object-cover object-[70%_center]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/40 to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 pb-20 md:pb-28 pt-40 w-full">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 backdrop-blur px-4 py-1.5 mb-8">
            <span className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-3.5 h-3.5 fill-white text-white" />
              ))}
            </span>
            <span className="text-xs tracking-wide text-white/80">
              Ausschließlich 5-Sterne-Bewertungen bei Google
            </span>
          </div>

          <h1 className="font-heading font-extrabold text-white tracking-tighter leading-[0.95] text-5xl sm:text-6xl lg:text-7xl">
            Tesla fahren.
            <br />
            <span className="text-white/60">Elektromobilität erleben.</span>
          </h1>

          <p className="mt-7 text-lg text-white/70 leading-relaxed max-w-xl">
            Mieten Sie einen gepflegten Tesla im Rhein-Main-Gebiet – mit
            persönlicher Einweisung und ehrlicher Mobilitätsberatung vom
            IHK-zertifizierten Mobilitätsmanager. Direkt bei Frankfurt, in
            Rödermark-Urbach.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="#kontakt"
              data-testid="hero-cta-anfrage"
              className="group inline-flex items-center justify-center gap-2 rounded-full bg-white text-black px-8 py-4 text-base font-medium hover:bg-white/85 transition-colors"
            >
              Jetzt anfragen
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href={`tel:${site.phoneTel}`}
              data-testid="hero-cta-anrufen"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 text-white px-8 py-4 text-base font-medium hover:bg-white/10 hover:border-white/50 transition-colors"
            >
              <Phone className="w-5 h-5" />
              Direkt anrufen
            </a>
          </div>

          <div className="mt-14 flex flex-wrap gap-x-10 gap-y-4 text-sm text-white/50">
            <span>Tesla Model 3 Long Range</span>
            <span className="hidden sm:inline">·</span>
            <span>Persönliche Übergabe & Einweisung</span>
            <span className="hidden sm:inline">·</span>
            <span>Region Frankfurt / Rödermark</span>
          </div>
        </div>
      </div>
    </section>
  );
};
